export const hoursBetween = (startDate: number, endDate: number): number => {
  const millisecondsPerHour = 1000 * 60 * 60;
  const differenceInMilliseconds = Math.abs(endDate - startDate);
  return Math.floor(differenceInMilliseconds / millisecondsPerHour);
}